import { defineTranslateKeys } from 'lib/tolgee'

export const translations = defineTranslateKeys({
  title: {
    defaultValue: 'Renomear nichos',
    key: 'RenameNichesForm-title',
  },
})
